/**
 * Safe localStorage wrapper that handles SecurityError in Safari
 * when cookies/storage are blocked by browser settings or MDM policies.
 */

function isLocalStorageAvailable(): boolean {
  try {
    const testKey = '__rf_storage_test__';
    localStorage.setItem(testKey, '1');
    localStorage.removeItem(testKey);
    return true;
  } catch {
    return false;
  }
}

const storageAvailable = isLocalStorageAvailable();

export function isStorageAvailable(): boolean {
  return storageAvailable;
}
const fallbackStore: Record<string, string> = {};

export function safeGetItem(key: string): string | null {
  if (storageAvailable) {
    try {
      return localStorage.getItem(key);
    } catch {
      return fallbackStore[key] ?? null;
    }
  }
  return fallbackStore[key] ?? null;
}

export function safeSetItem(key: string, value: string): void {
  if (storageAvailable) {
    try {
      localStorage.setItem(key, value);
      return;
    } catch {
      // fall through to in-memory
    }
  }
  fallbackStore[key] = value;
}

export function safeRemoveItem(key: string): void {
  if (storageAvailable) {
    try {
      localStorage.removeItem(key);
      return;
    } catch {
      // fall through to in-memory
    }
  }
  delete fallbackStore[key];
}

export function safeClear(): void {
  if (storageAvailable) {
    try {
      localStorage.clear();
      return;
    } catch {
      // fall through to in-memory
    }
  }
  Object.keys(fallbackStore).forEach(k => delete fallbackStore[k]);
}
